module.exports = __webpack_public_path__ + "img/3x.f227bca.jpg";